import { StoreState as AccountCreditRedeemStatus } from "./accountCreditRedeem";
import { StoreState as CouponState } from "./coupon";
import { StoreState as CouponsState } from "./coupons";
import { StoreState as IsGetRewardsLoadingStoreState } from "./isGetRewardsLoading";
import { StoreState as LedgetHeadState } from "./ledgerHead";
import { StoreState as RequestStatusState } from "./requestStatus";
import { StoreState as RewardsStoreState } from "./rewards";
import { StoreState as RewardStatsState } from "./rewardStats";
import { StoreState as ShopifyActiveDiscountsState } from "./shopifyActiveDiscounts";
import { StoreState as ShopifyActiveGiftCardsState } from "./shopifyActiveGiftCards";
import { StoreState } from "./index";

export function getAccountCreditRedeem(
  state: StoreState
): AccountCreditRedeemStatus {
  return state.accountCreditRedeem;
}

export function getCoupon(state: StoreState): CouponState {
  return state.coupon;
}

export function getCoupons(state: StoreState): CouponsState {
  return state.coupons;
}

export function getLedgerHead(state: StoreState): LedgetHeadState {
  return state.ledgerHead;
}

export function getRequestStatus(state: StoreState): RequestStatusState {
  return state.requestStatus;
}

export function getRewardStats(state: StoreState): RewardStatsState {
  return state.rewardStats;
}

export function getRewards(state: StoreState): RewardsStoreState {
  return state.rewards;
}

export function getShopifyActiveDiscounts(
  state: StoreState
): ShopifyActiveDiscountsState {
  return state.shopifyActiveDiscounts;
}

export function getShopifyActiveGiftCards(
  state: StoreState
): ShopifyActiveGiftCardsState {
  return state.shopifyActiveGiftCards;
}

export function isGetRewardsLoading(
  state: StoreState
): IsGetRewardsLoadingStoreState {
  return state.isGetRewardsLoading;
}

export const getShopifyVariants = (state: StoreState) => state.shopifyVariants;
